module.exports = __webpack_public_path__ + "img/sample-m-3.45882469.jpeg";